import * as React from 'react';
import { useSelector } from 'react-redux';

import { NewbuildingImageMobile } from '../../components/NewbuildingImageMobile';
import { selectNewbuildingImage } from '../../selectors/newbuilding';

export const NewbuildingImageMobileContainer: React.VFC = () => {
  const image = useSelector(selectNewbuildingImage);

  return <NewbuildingImageMobile src={image} />;
};
